import Vue from 'vue'
import Router from 'vue-router'
import _import from './_import';
import register from './register';
import pay from './pay';
import paygo from './paygo';


Vue.use(Router);

const routerMap = [
    {
        path: '/',
        name: 'index',
        component: _import('index')
    },
    {
        path: '/message/setting',
        name: 'setting',
        component: _import('message/setting')
    },  
    {
        path: '/about/contact',
        name: 'contact',
        component: _import('about/contact')
    }, 
    ...pay,
    ...paygo, 
    ...register,
];


export default new Router({
    mode: 'history',
    routes: routerMap
});



// WEBPACK FOOTER //
// ./src/router/index.js